import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://api.jinke-chem.com',
  timeout: 10000
})
instance.interceptors.request.use(function (config) {
  if (localStorage.getItem('lang') === 'cn' || localStorage.getItem('lang') === null) {
    config.data.lang = 1
  } else {
    config.data.lang = 2
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
instance.interceptors.response.use(function (res) {
  const data = res.data
  if (data.status === 200) {
    return data
  } else {
    throw data
  }
}, function (error) {
  return Promise.reject((error.response && error.response.data) || error)
})
export default instance



// WEBPACK FOOTER //
// ./src/js/ajax.js